const prefixApi = 'TPICAP_';

class StorageHelper {
  constructor(storage) {
    this._storage = storage;
  }

  set(key, item) {
    const prefixKey = `${prefixApi}${key}`;
    item = JSON.stringify(item);
    this._storage.setItem(prefixKey, item);
  }

  get(key) {
    const prefixKey = `${prefixApi}${key}`;
    const result = this._storage.getItem(prefixKey);
    return JSON.parse(result);
  }

  clear() {
    this._storage.clear();
  }
}

export default StorageHelper;



// WEBPACK FOOTER //
// ./src/utils/StorageHelper.js